<template>
    <section class="light-sand get-in-touch-section">
        <div class="spacing-default grid grid-cols-12">
            <div 
                class="get-in-touch-text offset-2 col-span-8" 
                v-html="globals.pagecontent.getInTouchText"
            ></div>

            <div class="col-span-full text-center lg:text-right">
                <!-- <a
                    @click="openModal('form')"
                    title="get in touch" 
                    class="button cta--mega inline-block"
                > -->
                <a
                    title="get in touch" 
                    class="button cta--mega inline-block"
                    href="mailto:info@walbert-schmitz.de"
                >
                    {{ globals.pagecontent.getInTouchButton }}
                </a>
            </div>

            <video
                :src="darkmode ? globals.pagecontent?.getInTouchVideo[1]?.path : globals.pagecontent?.getInTouchVideo[0]?.path"
                loop
                muted
                autoplay
                playsinline
            ></video>
        </div>
    </section>
</template>

<script setup lang="ts">
    import { useRequestStore } from '@/stores/requests'

    const requestStore = useRequestStore()
    const { globals, darkmode } = storeToRefs(requestStore)

    const openModal = <Function>(modalContent: string) => {
        useEvent('toggleModal', {
            open: true,
            content: modalContent
        })
    }
</script>